import { Search } from 'components/icons';
import { useTranslation } from 'react-i18next';
import { useGlobalSearch } from './';

export default function GlobalSearchTriggerButton() {
  const { t } = useTranslation();
  const { setIsActive } = useGlobalSearch();
  return (
    <button
      className="group inline-block h-14 cursor-pointer focus-visible:outline-none"
      onClick={() => setIsActive(true)}
      aria-label={t('labels.common.search-button-empty')}
    >
      <Search className="smd-group-focus-visible-primary h-6 w-6 rounded-sm stroke-2" />
    </button>
  );
}
